var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "black",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#E4E4E7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3672_74064",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3672_74064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0013 36.5833C33.043 36.5833 33.9284 36.2188 34.6576 35.4896C35.3867 34.7604 35.7513 33.875 35.7513 32.8333C35.7513 31.7917 35.3867 30.9062 34.6576 30.1771C33.9284 29.4479 33.043 29.0833 32.0013 29.0833C30.9596 29.0833 30.0742 29.4479 29.3451 30.1771C28.6159 30.9062 28.2513 31.7917 28.2513 32.8333C28.2513 33.875 28.6159 34.7604 29.3451 35.4896C30.0742 36.2188 30.9596 36.5833 32.0013 36.5833ZM32.0013 34.9167C31.418 34.9167 30.9249 34.7153 30.5221 34.3125C30.1194 33.9097 29.918 33.4167 29.918 32.8333C29.918 32.25 30.1194 31.7569 30.5221 31.3542C30.9249 30.9514 31.418 30.75 32.0013 30.75C32.5846 30.75 33.0777 30.9514 33.4805 31.3542C33.8832 31.7569 34.0846 32.25 34.0846 32.8333C34.0846 33.4167 33.8832 33.9097 33.4805 34.3125C33.0777 34.7153 32.5846 34.9167 32.0013 34.9167ZM25.3346 39.5C24.8763 39.5 24.4839 39.3368 24.1576 39.0104C23.8312 38.684 23.668 38.2917 23.668 37.8333V27.8333C23.668 27.375 23.8312 26.9826 24.1576 26.6562C24.4839 26.3299 24.8763 26.1667 25.3346 26.1667H27.9596L29.5013 24.5H34.5013L36.043 26.1667H38.668C39.1263 26.1667 39.5187 26.3299 39.8451 26.6562C40.1714 26.9826 40.3346 27.375 40.3346 27.8333V37.8333C40.3346 38.2917 40.1714 38.684 39.8451 39.0104C39.5187 39.3368 39.1263 39.5 38.668 39.5H25.3346ZM25.3346 37.8333H38.668V27.8333H35.293L33.7721 26.1667H30.2305L28.7096 27.8333H25.3346V37.8333Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my_profile.eb948a9b232a282a022f59287310568f.svg";
export { ForwardRef as ReactComponent };